// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collapsible-container{display:flex;flex-direction:column}.collapsible-container .anchor-child{display:flex;position:relative;transition:0.2s ease-in-out;cursor:pointer}.collapsible-container .anchor-child.collapsed+.expandable-child{opacity:0;max-height:0;overflow:hidden}.collapsible-container .anchor-child.no-expand{cursor:default}.collapsible-container .expandable-child{display:flex;opacity:1;max-height:5000px;transition:0.2s ease-in-out}\n", ""]);
// Exports
module.exports = exports;
